/**
 * /aprovafeo-orto-padrao-bkp — backup da LP do Aprova FEO na oferta PADRÃO
 * (de R$997 por R$597, cupom APROVAFEO), navegável durante a Semana da
 * Fisioterapia, quando /aprovafeo-orto exibe a oferta da ação.
 */
import { createFileRoute } from "@tanstack/react-router";

import { AprovafeoOrtoPage } from "@/routes/aprovafeo-orto";

export const Route = createFileRoute("/aprovafeo-orto-padrao-bkp")({
  head: () => ({
    meta: [
      { title: "AprovaFEO Traumato-Ortopedia · backup da oferta padrão" },
      {
        name: "description",
        content:
          "Versão de backup da LP do AprovaFEO com a oferta padrão, sem os elementos de ação promocional.",
      },
      { property: "og:title", content: "AprovaFEO Traumato-Ortopedia · backup da oferta padrão" },
      { property: "og:description", content: "LP do AprovaFEO na oferta padrão, fora de ação promocional." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <AprovafeoOrtoPage acao={false} />,
});
